export const DevelopmentChartColors = {
  Green: 'rgb(15, 154, 101, 0.6)',
  Red: 'rgb(205, 0, 57, 0.6)',
  Blue: 'rgb(39, 154, 255, 0.6)'
};
